import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { dispatch, select } from '@ngxs/store';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { tap } from 'rxjs/operators';
import { SiCardComponent } from '@siemens/element-ng/card';
import { SiIconComponent } from '@siemens/element-ng/icon';
import { SiModalService } from '@siemens/element-ng/modal';
import { AuthService } from '../../auth/services/auth.service';
import { EditTileDialogComponent } from '../../shared/components/edit-tile-dialog/edit-tile-dialog.component';
import { TileComponent } from '../../shared/components/tile/tile.component';
import { LoadReports } from '../../shared/state/reports/reports.actions';
import { ReportsState } from '../../shared/state/reports/reports.state';

@Component({
    selector: 'app-reports',
    templateUrl: './reports.component.html',
    styleUrls: ['./reports.component.scss'],
    imports: [TileComponent, SiIconComponent, SiCardComponent, TranslatePipe]
})
export class ReportsComponent implements OnInit {
    private readonly destroyRef = inject(DestroyRef);
    private readonly dialog = inject(SiModalService);
    private readonly authService = inject(AuthService);
    private readonly translateService = inject(TranslateService);
    private readonly loadReports = dispatch(LoadReports);

    protected readonly reports = select(ReportsState.reports);
    protected readonly isLoading = select(ReportsState.isLoading);
    protected readonly skeletonItems = Array.from({ length: 4 });

    public ngOnInit(): void {
        this.refreshReports();
        this.initRefreshOnLangChange();
    }

    private initRefreshOnLangChange(): void {
        this.translateService.onLangChange
            .pipe(
                takeUntilDestroyed(this.destroyRef),
                tap(() => this.refreshReports())
            )
            .subscribe();
    }

    protected addNewTile(): void {
        this.dialog.show(
            EditTileDialogComponent,
            {
                inputValues: { data: { mode: 'new', type: 'reports' } },
                ignoreBackdropClick: false,
                keyboard: true,
                animated: true,
                class: 'modal-lg',
                ariaLabelledBy: 'edit-tile-dialog-title'
            },
            'close'
        );
    }

    protected isAdmin(): boolean {
        return this.authService.isAdmin();
    }

    private refreshReports(): void {
        const lang = (
            this.translateService.getCurrentLang() ||
            this.translateService.getFallbackLang() ||
            'en'
        ).toLowerCase();
        void this.loadReports({ lang });
    }
}
